import { CloseIcon } from '@App/static/icons/ArrowIcons'
import { Button } from '../../../controls/Button'
import ModalWrapper from '../../ModalWrapper'
import { ConfirmModalParams } from '../model/types'
import s from './styles.module.scss'
import cn from 'clsx'

export function ConfirmationModal({ params }: { params: ConfirmModalParams }) {
  return (
    <ModalWrapper isOpen setIsOpen={params.onClose} styles={{ overlay: { zIndex: 1000 } }}>
      <div className={s.container}>
        <div className={s.header}>
          <CloseIcon className={s.closeIcon} onClick={params.onClose} />
        </div>
        <div className={s.content}>
          <div className={s.labels}>
            <div className={s.title}>{params.title}</div>
            <div className={s.description}>{params.description}</div>
          </div>
          <div className={s.buttons}>
            <Button
              {...params.cancelBtnProps}
              className={cn(s.closeButton, params.cancelBtnProps?.className)}
              onClick={params.onClose}
            >
              {params.closeText}
            </Button>
            <Button
              {...params.confirmBtnProps}
              className={cn(s.confirmButton, params.confirmBtnProps?.className)}
              onClick={params.onConfirm}
            >
              {params.confirmText}
            </Button>
          </div>
        </div>
      </div>
    </ModalWrapper>
  )
}
